import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { EventSelectionWithApplyDate } from '../commitmentEvents/commitmentEventSelectionContext'

type EmployerAgreementEventSelectionContext = {
  current: Optional<EventSelectionWithApplyDate>
  setCurrent: (event: Optional<EventSelectionWithApplyDate>) => void
}

const [useEmployerAgreementEventSelectionContext, Provider] =
  createRequiredContext<EmployerAgreementEventSelectionContext>(
    'EmployerAgreementEventSelectionContext',
  )

export { Provider, useEmployerAgreementEventSelectionContext }
